import { render } from "./ImageDetail.vue?vue&type=template&id=238184b1&scoped=true"
import script from "./ImageDetail.vue?vue&type=script&lang=js"
export * from "./ImageDetail.vue?vue&type=script&lang=js"

import "./ImageDetail.vue?vue&type=style&index=0&id=238184b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238184b1"]])

export default __exports__